import { SVGProps } from 'react'

export const ShareholderIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      {...props}
    >
      <path
        d='M11.6095 6.94281C12 6.55228 12 5.92375 12 4.66667C12 3.40959 12 2.78105 11.6095 2.39052M11.6095 6.94281C11.219 7.33333 10.5904 7.33333 9.33333 7.33333H6.66667C5.40959 7.33333 4.78105 7.33333 4.39052 6.94281M11.6095 6.94281C11.6095 6.94281 11.6095 6.94281 11.6095 6.94281ZM11.6095 2.39052C11.219 2 10.5904 2 9.33333 2L6.66667 2C5.40959 2 4.78105 2 4.39052 2.39052M11.6095 2.39052C11.6095 2.39052 11.6095 2.39052 11.6095 2.39052ZM4.39052 2.39052C4 2.78105 4 3.40959 4 4.66667C4 5.92375 4 6.55228 4.39052 6.94281M4.39052 2.39052C4.39052 2.39052 4.39052 2.39052 4.39052 2.39052ZM4.39052 6.94281C4.39052 6.94281 4.39052 6.94281 4.39052 6.94281Z'
        stroke='currentColor'
      />
      <path
        d='M8.66634 4.66667C8.66634 5.03486 8.36786 5.33333 7.99967 5.33333C7.63148 5.33333 7.33301 5.03486 7.33301 4.66667C7.33301 4.29848 7.63148 4 7.99967 4C8.36786 4 8.66634 4.29848 8.66634 4.66667Z'
        stroke='currentColor'
      />
      <path
        d='M12 4C10.8954 4 10 3.10457 10 2'
        stroke='currentColor'
        stroke-linecap='round'
      />
      <path
        d='M12 5.33398C10.8954 5.33398 10 6.22941 10 7.33398'
        stroke='currentColor'
        stroke-linecap='round'
      />
      <path
        d='M4 4C5.10457 4 6 3.10457 6 2'
        stroke='currentColor'
        stroke-linecap='round'
      />
      <path
        d='M4 5.33398C5.10457 5.33398 6 6.22941 6 7.33398'
        stroke='currentColor'
        stroke-linecap='round'
      />
      <path
        d='M2.66699 14.2589H4.17361C4.84752 14.2589 5.52868 14.3291 6.18454 14.4643C7.3447 14.7033 8.56622 14.7322 9.73829 14.5425C10.3162 14.449 10.8844 14.3059 11.3986 14.0577C11.8629 13.8336 12.4316 13.5177 12.8136 13.1639C13.1951 12.8107 13.5923 12.2325 13.8743 11.7805C14.1161 11.3929 13.9991 10.9175 13.6167 10.6287C13.1919 10.3079 12.5615 10.308 12.1367 10.6288L10.9319 11.539C10.465 11.8917 9.95497 12.2164 9.34738 12.3133C9.27433 12.3249 9.19777 12.3355 9.1179 12.3448M9.1179 12.3448C9.09385 12.3476 9.06951 12.3502 9.04487 12.3528M9.1179 12.3448C9.21509 12.324 9.31161 12.264 9.40216 12.185C9.83096 11.8107 9.85808 11.18 9.48603 10.7621C9.3997 10.6651 9.29869 10.5843 9.18637 10.5173C7.32148 9.40496 4.41994 10.2521 2.66699 11.4953M9.1179 12.3448C9.09357 12.35 9.0692 12.3528 9.04487 12.3528M9.04487 12.3528C8.69596 12.3886 8.28777 12.3979 7.83484 12.3551'
        stroke='currentColor'
        stroke-linecap='round'
      />
    </svg>
  )
}
